(() => {
  // SCAEL: Pickup-Bestand pro Standort über die Storefront API
  const TOKEN = 'a008481ea51f551a5cd3d6e6ff281989';
  const API = '/api/2026-07/graphql.json';
  const cache = {};

  const QUERY = `query ScaelPickupStock($id: ID!) {
    node(id: $id) {
      ... on ProductVariant {
        storeAvailability(first: 50) {
          nodes {
            quantityAvailable
            location { name }
          }
        }
      }
    }
  }`;

  if (!document.getElementById('scael-pickup-style')) {
    const style = document.createElement('style');
    style.id = 'scael-pickup-style';
    style.textContent = `
      pickup-availability-preview:has(scael-pickup-stock:not([data-done])) { visibility: hidden; }
      .scael-pickup-icon { display: flex; flex-shrink: 0; }
      .scael-pickup-row { display: inline-flex; align-items: center; gap: 0.3rem; }
    `;
    document.head.appendChild(style);
  }

  function normalize(name) {
    return String(name || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function fetchStock(variantId) {
    if (!cache[variantId]) {
      cache[variantId] = fetch(API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN
        },
        body: JSON.stringify({
          query: QUERY,
          variables: { id: `gid://shopify/ProductVariant/${variantId}` }
        })
      })
        .then((response) => response.json())
        .then((json) => {
          const nodes = json && json.data && json.data.node && json.data.node.storeAvailability
            ? json.data.node.storeAvailability.nodes
            : null;
          if (!nodes) throw new Error('SCAEL pickup: keine Bestandsdaten ' + JSON.stringify(json && json.errors ? json.errors : json));
          const map = {};
          nodes.forEach((node) => {
            map[normalize(node.location.name)] = Number(node.quantityAvailable) || 0;
          });
          return map;
        })
        .catch((error) => {
          delete cache[variantId];
          throw error;
        });
    }
    return cache[variantId];
  }

  function toggle(element, show) {
    if (element) element.style.display = show ? '' : 'none';
  }

  class ScaelPickupStock extends HTMLElement {
    connectedCallback() {
      const preview = this.closest('pickup-availability-preview');
      const variantId = this.dataset.variantId;
      if (!preview || !variantId) {
        this.setAttribute('data-done', '');
        return;
      }

      fetchStock(variantId)
        .then((map) => this.apply(map, preview))
        .catch((error) => console.warn(error))
        .finally(() => this.setAttribute('data-done', ''));
    }

    apply(map, preview) {
      const hasStock = (name) => (map[normalize(name)] || 0) > 0;

      let locations = [];
      try {
        locations = JSON.parse(this.querySelector('[data-scael-locations]').textContent);
      } catch (error) {
        return;
      }

      const firstInStock = locations.find((location) => hasStock(location.name));

      const available = preview.querySelector('[data-scael-available]');
      const contact = preview.querySelector('[data-scael-contact]');
      const icon = preview.querySelector('[data-scael-icon]');

      if (firstInStock && available) {
        const label = available.querySelector('[data-scael-label]');
        const time = available.querySelector('[data-scael-time]');
        if (label) label.innerHTML = firstInStock.label;
        if (time) time.textContent = firstInStock.time;
      }

      toggle(icon, !!firstInStock);
      toggle(available, !!firstInStock);
      toggle(contact, !firstInStock);

      const drawer = document.querySelector('pickup-availability-drawer');
      if (!drawer) return;

      drawer.querySelectorAll('[data-scael-location]').forEach((item) => {
        const inStock = hasStock(item.dataset.scaelLocation);
        toggle(item.querySelector('[data-scael-yes]'), inStock);
        toggle(item.querySelector('[data-scael-no]'), !inStock);
      });
    }
  }

  if (!customElements.get('scael-pickup-stock')) {
    customElements.define('scael-pickup-stock', ScaelPickupStock);
  }
})();